import globalData from './globalData'

export default globalData.l10n || {}
